var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretdown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3124 0H0.687552C0.501235 0 0.340164 0.0769603 0.204076 0.230753C0.0679876 0.384715 0 0.566942 0 0.777603C0 0.988264 0.0679876 1.17062 0.204076 1.3245L5.01652 6.76895C5.15276 6.92291 5.31383 7 5.5 7C5.68617 7 5.84739 6.92291 5.98336 6.76895L10.7958 1.32445C10.9317 1.17062 11 0.988264 11 0.77756C11 0.566942 10.9318 0.384715 10.7958 0.23071C10.6598 0.0767897 10.4986 0 10.3124 0Z",
    fill: "#5282F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretdown);
export default __webpack_public_path__ + "static/media/caretdown.12884f32ff4d96cf3d9637b4840f9f62.svg";
export { ForwardRef as ReactComponent };